"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOperationTrackingLink = void 0;
// Allowed event types to search through in azure portal
const azurePortalEventTypes = [{
  value: 'availabilityResult',
  tableName: 'availabilityResults',
  label: 'Availability'
}, {
  value: 'customEvent',
  tableName: 'customEvents',
  label: 'Custom Event'
}, {
  value: 'dependency',
  tableName: 'dependencies',
  label: 'Dependency'
}, {
  value: 'exception',
  tableName: 'exceptions',
  label: 'Exception'
}, {
  value: 'pageView',
  tableName: 'pageViews',
  label: 'Page View'
}, {
  value: 'request',
  tableName: 'requests',
  label: 'Request'
}, {
  value: 'trace',
  tableName: 'traces',
  label: 'Trace'
}];

/**
 * Gets operation tracking link under operation id and resource id
 */
const getOperationTrackingLink = ({
  operationResourceId: resourceId,
  operationId
}) => {
  const azurePortalSearchArguments = {
    tables: azurePortalEventTypes.map(({
      tableName
    }) => tableName),
    timeContextWhereClause: '|',
    filterWhereClause: `| where * has "${operationId}"| order by timestamp desc`,
    originalParams: {
      eventTypes: azurePortalEventTypes,
      timeContext: {
        durationMs: 259200000
      },
      filter: [],
      searchPhrase: {
        originalPhrase: operationId,
        _tokens: [{
          conjunction: 'and',
          value: operationId,
          isNot: false,
          kql: ` * has "${operationId}"`
        }]
      },
      sort: 'desc'
    }
  };
  return `https://portal.azure.com/#blade/AppInsightsExtension/BladeRedirect/BladeName/searchV1/ResourceId/${encodeURIComponent(resourceId)}/BladeInputs/${encodeURIComponent(JSON.stringify(azurePortalSearchArguments))}`;
};
exports.getOperationTrackingLink = getOperationTrackingLink;
